module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_5.1e3912d7.png";